import { render, staticRenderFns } from "./PazymosUzsakytos.vue?vue&type=template&id=e999d7d4&scoped=true&"
import script from "./PazymosUzsakytos.vue?vue&type=script&lang=js&"
export * from "./PazymosUzsakytos.vue?vue&type=script&lang=js&"
import style0 from "./PazymosUzsakytos.vue?vue&type=style&index=0&id=e999d7d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e999d7d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VDataTable,VRow})
